export default __webpack_public_path__ + "static/media/GPA_Banner_AboutUs.454f8215.png";